import script from "./PaymentCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentCard.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentCard.vue?vue&type=style&index=0&id=4b5150f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5150f2"]])

export default __exports__